module.exports = __webpack_public_path__ + "img/tu15.1b2c1887.png";